import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StaffGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    const user = this.authService.currentUser;
    if (user && user.is_staff) {
      return of(true);
    }
    if (user && !user.is_staff) {
      this.router.navigate(['/login']);
      return of(false);
    }
    return this.authService.initializeAuth().pipe(
      map(u => !!(u && u.is_staff)),
      tap(isStaff => {
        if (!isStaff) {
          this.router.navigate(['/login']);
        }
      }),
    );
  }
}